import _ from 'lodash';
import { createSelector } from 'reselect';

import Cart from '@arreeba/ristoranti-lib/lib/cart';
import {
  ORDER_TYPE_TAKEAWAY,
  ORDER_TYPE_DELIVERY,
} from '@arreeba/ristoranti-frontend-lib/lib/constants';


const ORDER_STEPS = {
  end: 5,
  payment: 4,
  voucher: 3,
  checkout: 3,
  cart: 2,
  menu: 1,
  order: 0,
};

export const orderStepSelector = createSelector(
  (state, props) => props.location.pathname,
  (fullLocation) => {
    if (!fullLocation) return 0;

    const lastUrlPart = fullLocation.substring(fullLocation.lastIndexOf('/') + 1);
    return ORDER_STEPS[lastUrlPart] || 0;
  },
);

export const orderLocationAddressSelector = createSelector(
  state => state.app.merchant.restaurants,
  (state, props) => props.params.orderType,
  (state, props) => props.params.restaurantId,
  state => state.order.deliveryLocation,
  (restaurants, orderType, restaurantId, deliveryLocation) => {
    if (orderType === ORDER_TYPE_TAKEAWAY) {
      const restaurant = _.find(restaurants, { id: restaurantId });
      return {
        address: restaurant.address,
        coords: {
          lat: restaurant.location.latitude,
          lng: restaurant.location.longitude,
        },
      };
    }

    return {
      address: deliveryLocation.description,
      coords: deliveryLocation.geometry.location,
    };
  },
);

export const orderOvercomeThreshold = createSelector(
  state => Cart.total(state.order.cart),
  (state, props) => props.params.orderType === ORDER_TYPE_DELIVERY,
  state => state.order.deliveryAreaCustomThreshold || 0,
  (cartTotal, isDelivery, threshold) => (cartTotal >= threshold && isDelivery) || !isDelivery,
);



// WEBPACK FOOTER //
// ./src/selectors/orderSelectors.js